import WkFileVue from './main.vue';

var WkFile = {};

WkFile.install = function (Vue) {
  var WkFileConstructor = Vue.extend(WkFileVue);
  var instance = new WkFileConstructor({
    el: document.createElement('div')
  });
  document.body.appendChild(instance.$el);

  Vue.prototype.$wkFile = instance;
};

export default WkFile;